import { createStore } from 'effector'

import { setAuthTokenFx } from './event'

export const $isAuthorized = createStore(false)
  .on(setAuthTokenFx, (_, token) => !!token)

export const $authToken = createStore('')
  .on(setAuthTokenFx, (_, token) => token)
